import type { Order } from "@graphql/generated/types";
import type { PaymentValues } from "@lib/utils/checkoutHelper";
import type { IPaymentStrategy } from "@interfaces/payment-method/PaymentStrategy";
import { AmazonResolver } from "./amazonResolver";
import { AmazonDefaultStrategy } from "./payment-method-strategies/amazonDefaultStrategy";

export class AmazonStrategy implements IPaymentStrategy {
    private resolver: AmazonResolver;

    constructor() {
        this.resolver = new AmazonResolver(
            new Map([["amazonDefault", new AmazonDefaultStrategy()]])
        );
    }

    resolve(order: Order): PaymentValues {
        return this.resolver.resolve(order);
    }
}
